import InputField from "@_common/InputRuleFeild";
import { convertCurrentDateWithTime } from "@_common/date-helpers";
// import { handleDownloadOnClick } from "@_common/downloadfile";
import {
  concatDotToDocumentString,
  concatDotToString,
  getEncodedKey,
} from "@_common/text-helpers";
import { getValue } from "@utils/lodash";
import React, { useState } from "react";
import { getFirstLetter } from "@_common/format-text";
import DragAndDropFileComponent from "@_common/file-drag-drop";
import { downloadURL } from "@services/auth.service";
import { saveAs } from "file-saver";
import { DownloadLegacyTaskFile } from "@services/email-template.service";
import { sanitizeInput } from "@_common/dompurify";

function LegacyTaskEditTask(props: any) {
  const {
    showUpdatePopup,
    setShowUpdatePopup,
    selfCompliance,
    setSelfCompliance,
    handleUploadDocuments,
    handleSubmitTask,
    submitLoading,
    selectedStatus,
    selectedObj,
    removeDocument,
    //upload
    handleDrop,
    uploadLoading,
    handleDragOver,
    disableUpload,
    inside,
  } = props;
  const [statusList] = useState([
    { value: "ASSIGNED", label: "Assigned" },
    { value: "POSING", label: "Posing" },
    { value: "COMPLIED", label: "Complied" },
    { value: "NON_COMPLIED", label: "Non Complied" },
    { value: "DELAYED", label: "Delayed" },
    { value: "DELAYED_REPORTED", label: "Delay Reported" },
    { value: "RE_OPENED", label: "Re Opened" },
    { value: "EVENT_NOT_OCCURED", label: "Event Not Occured" },
    { value: "AWAITING_APPROVAL", label: "Awaiting Approval" },
  ]);

  // Complied
  const checkCompiled = () => {
    return getValue(selfCompliance, `compliance_status`, "") === "ASSIGNED" ||
      getValue(selfCompliance, `compliance_status`, "") === "POSING" ||
      getValue(selfCompliance, `compliance_status`, "") === "RE_OPENED" ||
      getValue(selfCompliance, `compliance_status`, "") === "NON_COMPLIED"
      ? true
      : false;
  };
  // approved, Reopen
  const checkApprover = () => {
    return (getValue(selfCompliance, `compliance_status`, "") === "COMPLIED" ||
      getValue(selfCompliance, `compliance_status`, "") === "DELAYED" ||
      getValue(selfCompliance, `compliance_status`, "") ===
        "EVENT_NOT_OCCURED" ||
      getValue(selfCompliance, `compliance_status`, "") ===
        "DELAYED_REPORTED") &&
      getValue(selectedObj, `approval_status`, "") === "PENDING"
      ? true
      : false;
  };
  const [isLoading, setIsLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState<any>(null);
  const handleDownloadOnClick = async (
    url: string,
    name: string,
    index: number,
    key: string
  ) => {
    try {
      setSelectedIndex(index);
      setIsLoading(true);
      // let resp = await downloadURL(getEncodedKey(url));
      let resp = await DownloadLegacyTaskFile(key);
      if (resp) {
        let url = getValue(resp, `data.url`, "")
          ? getValue(resp, `data.url`, "").includes("https://")
            ? getValue(resp, `data.url`, "")
            : `https://${getValue(resp, `data.url`, "")}`
          : getValue(resp, `data.url`, "");
        saveAs(url, name);
        setIsLoading(false);
        setSelectedIndex(null);
      } else {
        setIsLoading(false);
        setSelectedIndex(null);
      }
    } catch (error) {
      setIsLoading(false);
      setSelectedIndex(null);
    }
  };
  return (
    <div
      className={`compelte-task-wrapper ${
        showUpdatePopup ? "compelte-task-wrapper--active" : ""
      }`}
    >
      <div className="compelte-task-wrapper__header d-flex align-items-center justify-content-between">
        <h6 className="compelte-task-wrapper__title">Edit Legacy Task</h6>
        <img
          src="/images/close-white.svg"
          className="img-fluid navigation-bar-wrapper__close-btn"
          onClick={() => {
            setShowUpdatePopup(false);
          }}
        />
      </div>
      <div className="compelte-task-wrapper__body d-flex h-100">
        <div className="compelte-task-wrapper__completion compelte-task-wrapper__completion_fixed_button flex-2 padd-0">
          <div className="complete-task-wrapper__completion-holder">
            <div className="compelte-task-wrapper__common-header">
              <h5 className="compelte-task-wrapper__common-title">
                Task Completion
              </h5>
            </div>
            <div className="compelte-task-wrapper__form mt-0">
              <div className="compelte-task-wrapper__form-group mt-0">
                <label className="compelte-task-wrapper__label">Remarks</label>
                <textarea
                  placeholder="Remarks"
                  className="w-100 compelte-task-wrapper__text-area"
                  rows={3}
                  value={getValue(selfCompliance, `remark`, "")}
                  onChange={(e: any) =>
                    setSelfCompliance({
                      ...selfCompliance,
                      remark: sanitizeInput(e.target.value),
                    })
                  }
                ></textarea>
              </div>
              <div className="compelte-task-wrapper__form-group compelte-task-wrapper__label">
                <p className="mb-2">
                  Files Upload{" 	"}
                  {getValue(
                    selectedObj,
                    `self_compliance.document_required`,
                    ""
                  )
                    ? "*"
                    : ""}
                </p>
                <DragAndDropFileComponent
                  uploadFile={
                    !uploadLoading ? handleUploadDocuments : disableUpload
                  }
                  name="file"
                  multiple
                  // className="d-none"
                  classes="bulk-upload_drag-n-drop-wrapper position-absolute"
                  fileName={getValue(props, `importedFile.name`, "")}
                  setImportTedFile={props.setImportTedFile}
                />
                
                <div className="compelte-task-wrapper__uploaded-files mt-2">
                  <ul>
                    {getValue(selfCompliance, `document_ids`, []).map(
                      (item: any, key: number) => {
                        return (
                          <li className="compelte-task-wrapper__uploaded d-flex align-items-center justify-content-between cursor-pointer">
                            {selectedIndex === key && isLoading ? (
                              <>
                                <span>Downloading...</span>
                                <img
                                  src="/images/close-black.svg"
                                  onClick={() =>
                                    removeDocument(getValue(item, `id`, ""))
                                  }
                                />
                              </>
                            ) : (
                              <>
                                <span
                                  onClick={() =>
                                    !selectedIndex &&
                                    !isLoading &&
                                    handleDownloadOnClick(
                                      getValue(item, `uploadedDocumentLocation`, ""),
                                      getValue(item, `documentName`, ""),
                                      key,
                                      getValue(item, `key`, ""),
                                    )
                                  }
                                >
                                  <img className="me-2" src="/images/download.svg" />
                                  
                                  {concatDotToDocumentString(
                                    getValue(item, `documentName`, "")
                                      ? getValue(item, `documentName`, "")
                                      : getValue(item, `name`, "")
                                  )}
                                  {getValue(item, `extension`, "")}
                                </span>

                                {getValue(item, `is_client`, "") == true ?  (
                                  <img
                                    src="/images/close-black.svg"
                                    onClick={() =>
                                      removeDocument(getValue(item, `id`, ""))
                                    }
                                  />
                                ) : (
                                  ""
                                )}
                              </>
                            )}
                          </li>
                        );
                      }
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {getValue(props, `permissions`, []).includes("update") ? (
            <>
              <div className="compelte-task-wrapper__cta d-flex align-items-center">
                <button
                  className="ascent-button ascent-button--primary"
                  // onClick={() => handleSubmitTask("RE_OPENED")}
                  onClick={() => setShowUpdatePopup(false)}
                  disabled={selectedStatus === "RE_OPENED" && submitLoading}
                >
                  Cancel
                </button>
                <button
                  className="ascent-button ascent-button--secondary"
                  onClick={() => handleSubmitTask("APPROVED")}
                  disabled={selectedStatus === "APPROVED" && submitLoading}
                >
                  {/* {selectedStatus === "APPROVED" && submitLoading
                    ? "Please wait..."
                    : "Approve"} */}
                  Submit
                </button>
              </div>
            </>
          ) : null}
        </div>
        {/* {getValue(props, `selectedIDs.length`, 0) === 1 
        || getValue(props, `inside`, "") == true  
        &&( */}
        {(getValue(props, "selectedIDs.length", 0) === 1 ||
          getValue(props, "inside", "") === true) && (
          <div className="compelte-task-wrapper__response flex-1">
            <div className="compelte-task-wrapper__common-header">
              <h5 className="compelte-task-wrapper__common-title">Status</h5>
            </div>
            <div className="compelte-task-wrapper__form ">
              <div className="grid">
                <div className="compelte-task-wrapper__form-group input-grid-item">
                  <InputField
                    inputType="INPUT_REACT_SELECT_MODAL"
                    placeholder="Enter Status"
                    className="form-control w-100"
                    name="status"
                    id="status"
                    value={statusList.filter(
                      (item: object) =>
                        getValue(item, `value`, "") ===
                        getValue(selfCompliance, `status`, "")
                    )}
                    options={statusList}
                    onChange={(e: any) =>
                      setSelfCompliance({
                        ...selfCompliance,
                        status: e.value,
                      })
                    }
                    label="Status"
                  />
                </div>
              </div>

              {/* <div className="d-flex justify-content-between align-items-center mt-2 mb-3">
              <h6>Legal Due Date : </h6>
              <p>{getValue(props, `selectedLegalDueDate`, "")}</p>
            </div> */}

              <div className="compelte-task-wrapper__form-group">
                {(checkApprover() ||
                  getValue(props, `main_route`, "") === "approved-task") &&
                  (getValue(selectedObj, `executor_completion_date`, "") ||
                    getValue(selectedObj, `remarks`, "")) && (
                    <div className="popup-margin-bottom">
                      <div className="circle">
                        <p className="text">
                          {getFirstLetter(
                            getValue(selectedObj, `executor.first_name`, "")
                          )}
                        </p>
                      </div>
                      <div className="mt-2">
                        <h6 className="compelte-task-wrapper__label_popup ">
                          Executor -{" "}
                          {getValue(selectedObj, `executor.first_name`, "") +
                            " " +
                            getValue(selectedObj, `executor.last_name`, "")}
                        </h6>
                        <p className="subtext_popup mb-3">
                          Updated on{" "}
                          {convertCurrentDateWithTime(
                            getValue(
                              selectedObj,
                              `executor_completion_date`,
                              ""
                            )
                          )}
                        </p>
                        <p className="subtext-header mb-1">
                          {getValue(selectedObj, `remarks`, "")}
                        </p>
                      </div>
                    </div>
                  )}
                {(checkCompiled() ||
                  getValue(props, `main_route`, "") === "approved-task") &&
                  (getValue(selectedObj, `evaluator_completion_date`, "") ||
                    getValue(selectedObj, `evaluator_comments`, "")) && (
                    <div className="popup-margin-bottom">
                      <div className="circle">
                        <p className="text">
                          {getFirstLetter(
                            getValue(selectedObj, `evaluator.first_name`, "")
                          )}
                        </p>
                      </div>
                      <div className="mt-2">
                        <h6 className="compelte-task-wrapper__label_popup ">
                          Evaluator -{" "}
                          {getValue(selectedObj, `evaluator.first_name`, "") +
                            " " +
                            getValue(selectedObj, `evaluator.last_name`, "")}
                        </h6>
                        <p className="subtext_popup mb-2">
                          Updated on{" "}
                          {convertCurrentDateWithTime(
                            getValue(
                              selectedObj,
                              `evaluator_completion_date`,
                              ""
                            )
                          )}
                        </p>
                        <p className="subtext-header mb-1">
                          {getValue(selectedObj, `evaluator_comments`, "")}
                        </p>
                      </div>
                    </div>
                  )}
                {(checkApprover() ||
                  getValue(props, `main_route`, "") === "approved-task") && (
                  <>
                    {/* {getValue(selfCompliance, `remarks`, "") && (
                    <div className="popup-margin-bottom ">
                      <img
                        src="/images/comments.svg"
                        className="img-fluid"
                        style={{
                          height: "30px",
                          width: "30px",
                          marginRight: "10px",
                        }}
                      />
                      <div className="mt-2 mb-3">
                        <label className="compelte-task-wrapper__label">
                          Remarks
                        </label>
                        <p>{getValue(selfCompliance, `remarks`, "")}</p>
                      </div>
                    </div>
                  )} */}
                    {getValue(selfCompliance, `non_compliance_reason`, "") && (
                      <div className="popup-margin-bottom ">
                        <img
                          src="/images/comments.svg"
                          className="img-fluid"
                          style={{
                            height: "30px",
                            width: "30px",
                            marginRight: "10px",
                          }}
                        />
                        <div className="mt-2 mb-2">
                          <label className="compelte-task-wrapper__label">
                            Non Compliance Reason
                          </label>
                          <p className="subtext-header mb-1 mt-1">
                            {getValue(
                              selfCompliance,
                              `non_compliance_reason`,
                              ""
                            )}
                          </p>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {/* {(checkCompiled() ||
                getValue(props, `main_route`, "") === "approved-task") &&
                getValue(selectedObj, `evaluator_comments`, "") && (
                  <div className="popup-margin-bottom ">
                    <img
                      src="/images/comments.svg"
                      className="img-fluid"
                      style={{
                        height: "30px",
                        width: "30px",
                        marginRight: "10px",
                      }}
                    />
                    <div className="mt-2 mb-3">
                      <label className="compelte-task-wrapper__label">
                        Evaluator Comments
                      </label>
                      <p>{getValue(selectedObj, `evaluator_comments`, "")}</p>
                    </div>
                  </div>
                )} */}

                {
                  <>
                    {getValue(selectedObj, `auditor_comments`, "") && (
                      <div className="popup-margin-bottom ">
                        <img
                          src="/images/comments.svg"
                          className="img-fluid"
                          style={{
                            height: "30px",
                            width: "30px",
                            marginRight: "10px",
                          }}
                        />
                        <div className="mt-2 mb-3">
                          <label className="compelte-task-wrapper__label_popup">
                            Auditor Comments
                          </label>
                          {getValue(
                            selectedObj,
                            `audit_completed_date`,
                            ""
                          ) && (
                            <p className="subtext_popup mb-2">
                              Updated on{" "}
                              {convertCurrentDateWithTime(
                                getValue(
                                  selectedObj,
                                  `audit_completed_date`,
                                  ""
                                )
                              )}
                            </p>
                          )}
                          <p className="subtext-header mb-1">
                            {getValue(selectedObj, `auditor_comments`, "")}
                          </p>
                        </div>
                      </div>
                    )}
                  </>
                }
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default LegacyTaskEditTask;
